module.exports = __webpack_public_path__ + "media/images/opayo-logo-9b8fde1adc03ded45d2a887a004c8b9d.jpg";